<template>
    <div>
        <b-button as="button" class="button is-primary next-button rolltext-button" @click="nextStep()">
                <p v-html="firstline+arrow"></p>
                <p v-html="secondline + arrow"></p>
        </b-button>
    </div>
</template>

<script>
import mixin from "../../components/form/steps/travel_step_mixin";

export default {
    mixins: [mixin],
    props:{
        firstline:{
            type:String,
            default:'Vraag je pakket aan',
        },
        secondline:{
            type:String,
            default:'Grijp het aanbod',
        },
    },
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        },
        isMobile() {
            return window.innerWidth <= 768;
        },
        arrow(){
            return '<img src="/images/fr_multigift_carousel/arrow-next.png" alt="">';
        }
    }
};
</script>

